import React, { useCallback, useState } from 'react';
import URL from 'url-parse';
import qs, { ParsedQs } from 'qs';
import { v4 as uuid4 } from 'uuid';
import { TypedMemo } from '../../common/types';
import { SMLPreviewProps } from './props';
import { openExternal } from '../../../utils/openExternal';
import { SMLPreviewRenderer } from './SMLPreviewRenderer';
import { usePreviewPageLang } from './usePreviewPageLang';

const SMLPreviewComponent: React.FC<SMLPreviewProps> = ({
  type = 'column',
  smartLink,
  onPreviewMessageEvent,
  showPublished,
  showOpenPreviewBar = true,
  selectedWidgetUUID,
  hoveredWidgetUUID,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const withLang = usePreviewPageLang();
  const togglePreviewSidebar = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  let { previewUrl, editUrl } = smartLink.recentSmartLinkVersion;
  if (showPublished === true && smartLink.publishedSmartLinkVersion) {
    // The frame loads the platform domain: the CSP cannot allow an artist's custom domain. The
    // "open" button keeps the address the fans see.
    previewUrl = smartLink.shareUrl;
    editUrl = smartLink.platformShareUrl ?? smartLink.shareUrl;
  }
  const openPreview = useCallback(() => {
    if (!previewUrl) {
      return;
    }
    const url = new URL<ParsedQs>(previewUrl, (query) => qs.parse(query, { ignoreQueryPrefix: true }));
    url.set('query', { ...url.query, rand: uuid4() });
    openExternal(withLang(url.toString())).catch(console.error);
  }, [previewUrl, withLang]);

  return (
    <SMLPreviewRenderer
      editableSmartLink={showPublished === true ? undefined : smartLink}
      iframeUrl={editUrl}
      type={type}
      openPreview={showPublished === true ? undefined : openPreview}
      showOpenPreviewBar={showOpenPreviewBar}
      togglePreviewSidebar={togglePreviewSidebar}
      isPreviewSidebarOpen={isOpen}
      onPreviewMessageEvent={onPreviewMessageEvent}
      selectedWidgetUUID={selectedWidgetUUID}
      hoveredWidgetUUID={hoveredWidgetUUID}
    />
  );
};

export const SMLPreview = TypedMemo(SMLPreviewComponent);
